
import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/';
import { map } from 'rxjs/operators';
// import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AlertService, SectorOfEnterpriseService, AppService } from '../_services/index';
import $ from 'jquery/dist/jquery';
import {NgbModal, NgbActiveModal,NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

class SectorOfEnterprise {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: 'app-sector-of-enterprise',
  templateUrl: './sector-of-enterprise.component.html'
})
export class SectorOfEnterpriseComponent implements OnInit {

  dtOptions: DataTables.Settings = {}; //  DataTable
    dtTrigger = new Subject(); //  DataTable
    sectorofenterpriseList: SectorOfEnterprise[] = []; // Table Data list
    isSubmitted = false;
    // countryAddForm: FormGroup;
    getSectorofenterprise = {
      id:'',
      name: '',
      description: '',
      is_active: 'N'
    };
    modalReference:NgbActiveModal;
    modalTitle:string;
    constructor(
                public router: Router,
                private dataService:SectorOfEnterpriseService,
                private alertService: AlertService,
                private AppService: AppService,
                private modalService: NgbModal
               ) { }
    sectorofenterprise = {
      id:'',
      name: '',      
      description: '',
      is_active: 'Y'
    };
    showloding = true;
    lodingImage = false;

    ngOnInit() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.allSectorofenterprise();
    }
  
    allSectorofenterprise(){
      this.loadShow();
      this.dataService.getAllSectorofenterprise()
          .pipe().subscribe(data => { 
            this.sectorofenterpriseList = data['sectorofenterprise']; 
            this.dtTrigger.next(); // Data Table
            this.loadHide();
          });
    }
  
    open(content) {
  
      if (this.getSectorofenterprise.id !=null) {
        this.getSectorofenterprise.id='';
      }
      this.isSubmitted = false;
      this.sectorofenterprise.name = '',
      this.sectorofenterprise.description = '',
      this.sectorofenterprise.is_active = 'Y';
      this.modalTitle = "Add Sector of enterprise";
      this.modalReference = this.modalService.open(content);
    }
  
    edit(id,content){
      this.loadShow();
      this.dataService.getSectorofenterprise(id)
          .pipe().subscribe(data => { 
                  this.getSectorofenterprise = data['sectorofenterprise']; 
                  this.sectorofenterprise = {
                        id:this.getSectorofenterprise.id,
                        name:this.getSectorofenterprise.name,                        
                        description:this.getSectorofenterprise.description,
                        is_active:this.getSectorofenterprise.is_active
                  };
                  this.loadHide();
                  this.modalTitle = "Edit sector of enterprise";
                  this.modalReference = this.modalService.open(content);
          });
    }

 
  
  
    save(val,f){
      this.isSubmitted = true;
      if(f.form.valid) {
        this.loadShow()
        if(val.id == '') {
          this.dataService.save(this.sectorofenterprise)
              .pipe().subscribe(data =>{
                if(data['status']==200){
                  this.loadHide()
                  this.modalReference.close();
                  this.dtTrigger = new Subject(); //  DataTable
                  this.alertService.success('Sector of enterprise saved successfully', true);
                  this.allSectorofenterprise();
                }
                else if(data['status'] == 422){
                  this.alertService.error(data.mesg.name)
                  document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
                  this.loadHide()
                }else{
                  this.alertService.error("errors")
                  document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
                  this.loadHide()
                }               
              },error =>{
                this.loadHide()
                this.alertService.error(error);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              });
        }else{
          this.dataService.sectorofenterpriseUpdate(this.sectorofenterprise)
              .pipe().subscribe(data =>{
                if(data['status'] == 200){
                  this.loadHide()
                  this.modalReference.close();
                  this.dtTrigger = new Subject(); //  DataTable
                  this.alertService.success('Sector of enterprise updated successfully', true);
                  this.allSectorofenterprise();
                }
              else if(data['status'] ==300){
                this.loadHide()
                this.alertService.error(data.mesg);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              }
              
              },error =>{
                this.loadHide()
                this.alertService.error(error);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              });
        }
      }
    }
  
    delete(id){
      if(confirm("Are you sure to delete")) {
        this.dataService.sectorofenterpriseDelete(id)
            .pipe().subscribe(data =>{
              if(data['status']==200){
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Sector of enterprise deleted successfully', true);
                this.allSectorofenterprise();
              }else{
                this.alertService.error('Sector of enterprise error');
              }
            },error =>{
              this.alertService.error(error);
            });
      }
    }
  
    loadShow(){
      this.showloding = true;
      this.lodingImage = false;
    }
  
    loadHide(){
      this.showloding = false;
      this.lodingImage = true;
    }

}
